<script>
import {defineComponent, ref, watch, computed} from "vue";
import {useRouter, useRoute} from "vue-router";
import {useStore} from "vuex";

import Editor from "primevue/editor";
import Button from "primevue/button";
import MainCard from "@/components/cards/MainCard";
import FileUpload from "@/components/FileUpload";
import BuilderLocationsTable from "@/components/tables/BuilderLocationsTable.vue";

export default defineComponent({
  components: {Editor, MainCard, FileUpload, Button, BuilderLocationsTable},
  props: {
    formData: {
      type: Object,
      required: true,
    },
    locationTypes: {
      type: Array,
      required: false,
    },
    errors: {
      type: Object,
      required: true,
    }
  },
  emits: ['changeFormData', 'toggleChangePointLocationType'],
  setup(props, {emit}) {
    const form = ref(props.formData);
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const lang = computed(() => store.getters.getLang);

    const points = ref(props.formData.location_points || []);

    const changePointEvent = (data) => {
      emit('toggleChangePointLocationType', data, 'location');
    }

    const toPointsEdit = async () => {
      try {
        await router.push({name: 'building-locations-points-edit', params: {id: route.params.id}})
      } catch (e) {
        console.error(e);
      }
    };

    const toPointCreate = async () => {
      await router.push({name: 'building-locations-points-create', params: {id: route.params.id}});
    };

    watch(() => form.value, () => emit('changeFormData', form.value), {deep: true});
    const locationField = computed(() => `location_${lang.value}`);
    const locationError = computed(() => props.errors?.[locationField.value]);

    return {form, toPointsEdit, toPointCreate, changePointEvent, points, locationField, locationError};
  }
});
</script>

<template>
  <section class="py-2 mb-3">
    <div class="grid">
      <div class="col-12">
        <MainCard title="Описание расположения">
          <div class="grid">
            <div class="col-12">
              <Editor v-model="form[locationField]" class="w-full"></Editor>
              <span v-if="locationError" class="text-xs color-error">
                {{ locationError[0] }}
              </span>
            </div>
          </div>
        </MainCard>
      </div>
    </div>
  </section>

  <template v-if="locationTypes ?? []">
    <section class="py-2 mb-3">
      <div class="flex justify-content-between">
        <span class="text-3xl font-bold">Ближайшие точки на карте</span>
        <div class="flex">
          <Button @click="toPointsEdit" label="Редактировать" class="btn-black-20-outlined"/>
          <Button @click="toPointCreate" label="Добавить точку" class="btn-primary ml-2"/>
        </div>
      </div>
    </section>
    <section class="py-2 mb-3">
      <BuilderLocationsTable
          @toggleChangePointType="changePointEvent"
          :locationTypes="locationTypes"
          :locations="points"
      />
    </section>
  </template>
</template>

<style scoped>

</style>